import VuexPersistence from 'vuex-persist'

const PERSISTED_MUTATIONS = new Set([
  'enterStory',
  'SET_PAGE',
  'setPaymentToken',
  'CLEAR_PAYMENT_TOKEN',
  'addOrder',
  'setCustomer',
  'SET_QUERY_PARAMS',
  'SET_QUERY_STRING',
  'setSessionId',
  'setContext',
  'INCREMENT_PURCHASE_ATTEMPTS'
])

export default ({ store }) => {
  window.onNuxtReady(() => {
    new VuexPersistence({
      storage: window.sessionStorage,
      filter: mutation => PERSISTED_MUTATIONS.has(mutation.type),
      reducer: state => ({
        analytics: state.analytics,
        brand: state.brand,
        route: state.route,
        paymentToken: state.paymentToken,
        purchaseAttempts: state.purchaseAttempts,
        orders: state.orders,
        customer: state.customer,
        queryParameters: state.queryParameters,
        sessionId: state.sessionId,
        'split-testing': state['split-testing']
      })
    }).plugin(store)
  })
}
